module.exports = __webpack_public_path__ + "static/MapBackground03-44c87e927d7b29c48b9f76394ad520fe.jpg";